import { CohesionProvider } from "@redventures/cohesion-utils-react";

export const withCohesion = ({ App, assets }) => {
  const CohesionProviderHOC = (props) => (
    <CohesionProvider components={assets}>
      <App {...props} />
    </CohesionProvider>
  );
  return CohesionProviderHOC;
};
